<template>
    <div
        class="container-history-earn-point main-layout addcode page-otp coffee-changetel"
    >
        <HeaderTitleSvg :setHref="'changetel'" :showLogo="true" />
        <div v-if="isLoaded" class="mx-4">
            <div class="logo">
                <img src="@/assets/home/logo-new-theme.png" />
            </div>
            <div class="box-changetel">
                <div class="otp-main-change">
                    <div class="otp-header">
                        <div class="text-center">
                            <img src="@/assets/icon/title-otp.svg" />
                        </div>
                        <div class="otp-container text-center">
                            <div class="otp-desc otp-desc-new my-3">
                                <span> ระบบได้ส่งรหัส OTP </span>
                                <br />
                                <span> ไปยังเบอร์โทรศัพท์มือถือ </span>
                            </div>
                            <div class="otp-detail">
                                <div class="contact-number">
                                    {{ formatted(tel) }}
                                </div>
                                <div class="ref-code">
                                    รหัสอ้างอิง {{ refcode }}
                                </div>
                            </div>
                            <div class="text-center">
                                <label
                                    for="input-otp"
                                    :class="{ 'input-otp': !isErrorMessage }"
                                >
                                    <div class="d-flex justify-content-center">
                                        <div
                                            class="box-input-otp"
                                            :class="{
                                                error: !validateBorderOTP,
                                            }"
                                        >
                                            {{ otp[0] }}
                                        </div>
                                        <div
                                            class="box-input-otp"
                                            :class="{
                                                error: !validateBorderOTP,
                                            }"
                                        >
                                            {{ otp[1] }}
                                        </div>
                                        <div
                                            class="box-input-otp"
                                            :class="{
                                                error: !validateBorderOTP,
                                            }"
                                        >
                                            {{ otp[2] }}
                                        </div>
                                        <div
                                            class="box-input-otp"
                                            :class="{
                                                error: !validateBorderOTP,
                                            }"
                                        >
                                            {{ otp[3] }}
                                        </div>
                                        <div
                                            class="box-input-otp"
                                            :class="{
                                                error: !validateBorderOTP,
                                            }"
                                        >
                                            {{ otp[4] }}
                                        </div>
                                        <div
                                            class="box-input-otp"
                                            :class="{
                                                error: !validateBorderOTP,
                                            }"
                                        >
                                            {{ otp[5] }}
                                        </div>
                                    </div>
                                </label>
                            </div>
                            <input
                                type="tel"
                                id="input-otp"
                                class="input-otp-dummy"
                                maxlength="6"
                                v-model="otp"
                                @input="onOtpChange()"
                            />
                            <div
                                class="err-otp"
                                v-if="isErrorMessage && !validateBorderOTP"
                            >
                                {{ errorMessage }}
                            </div>
                            <div class="resend" v-if="isExpireTime">
                                {{ "ส่ง OTP ได้อีกครั้งภายใน" }}
                                <span class="timer">{{
                                    timeHelper.displayTime
                                }}</span>
                            </div>
                            <div
                                class="resend-otp"
                                v-if="!isExpireTime"
                                :class="{ expired: !isExpireTime }"
                                @click="resendOtp()"
                            >
                                {{ "ส่งรหัส OTP อีกครั้ง" }}
                            </div>
                        </div>
                        <div
                            :class="{ disabled: validateBtn }"
                            class="otp-btn"
                            @click="validateBtn ? null : onSubmitOtp()"
                        >
                            {{ "ยืนยันรหัส" }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <b-modal
                id="modalSuccessUpdate"
                centered
                hide-header
                hide-footer
                no-close-on-backdrop
                no-close-on-esc
            >
                <div class="success-main">
                    <div
                        class="close-btn"
                        @click="$bvModal.hide('modalSuccessUpdate')"
                    >
                        <img src="@/assets/profile/close@2x.png" alt="" />
                    </div>
                    <div class="success-header">
                        <div class="title-scc">
                            <h2>บันทึกข้อมูลสำเร็จ</h2>
                            <p>ระบบได้บันทึกข้อมูลของท่านสำเร็จแล้ว</p>
                        </div>
                    </div>
                    <div class="success-btn" @click="$router.push('/profile')">
                        กลับหน้าข้อมูลของฉัน
                    </div>
                </div>
            </b-modal>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
// helper
// import Util from '@/helper/Utility.js';
// import Locale from '@/helper/locale/locale.js';
import Account from "@/helper/AccountHelper.js";
//mixin
import Mixin from "@/mixin/Mixin";
import AccountMixin from "@/mixin/AccountMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
// component
import HeaderTitleSvg from "@/components/Header/HeaderTitleSvg.vue";
import TimerHelper from "@/helper/TimerHelper.js";
// import ProfilePicture from "../component/ProfilePicture.vue";
// Service
import BzbsProfile from "@/core/Account/service/BzbsProfile.js";
import BzbsApi from "@/core/Account/service/BzbsProfile.js";
import CacheHelper from "@/helper/CacheHelper.js";
// import moment from "moment";
import BzbsOtp from "@/core/Otp/service/BzbsOtp.js";
import AccountHelper from "../../../helper/AccountHelper.js";

export default {
    name: "editprofile",
    components: {
        HeaderTitleSvg,
    },
    mixins: [Mixin, AccountMixin, LocaleMixin, ErrorApiMixin],
    data: function () {
        return {
            telNumber: this.$route.query.tel,
            cacheHelper: new CacheHelper(),
            // lbl: Locale.getLbl(),
            isLogin: false,
            objProfile: {},
            modelProfile: null,
            isFirstSave: true,
            errorInfo: [],
            errorResponse: "",
            isLoaded: false,

            isDisabledSubmit: true,

            bzbConfig: Vue.bzbsConfig,

            timeHelper: new TimerHelper(),
            isExpireTime: false,
            validateBorderOTP: true,
            otp: "",
            tel: "",
            refcode: "",
            channel: "ssoupdate",
            resend: false,

            isErrorMessage: false,
            errorMessage: "",
            validateBtn: true,
        };
    },
    created: function () {
        this.getProfile();
        this.onclickOtp();
    },
    methods: {
        formatted: function (input) {
            var n1, n2, n3;
            if (input) {
                n1 = input.substr(0, 3);
                n2 = input.substr(3, 3);
                n3 = input.substr(6);
                input = n1 + "-" + n2 + "-" + n3;
            }
            return input;
        },
        //#region mixin function
        accountInitiated: function () {
            this.objUser = Account.getCacheUser();
            this.modelProfile = this.objProfile;
            // console.log(this.modelProfile);
        },
        async getProfile() {
            this.handleLoading(true);

            try {
                const res = await BzbsApi.getProfileSSO(
                    this.cacheHelper.getCache("BzbsUser").token
                );
                this.objProfile = res.data.SSOUser;
                let fullName = `${this.objProfile.FirstName} ${this.objProfile.LastName}`;
                this.modelProfile.firstName = fullName;
                this.modelProfile.ContactNo = this.objProfile.ContactNumber;
                this.modelProfile.gender = this.objProfile.Gender;
                this.modelProfile.email = this.objProfile.ProEmail;
                this.modelProfile.zipcode = this.objProfile.Zipcode;
                this.modelProfile.province = this.objProfile.ProvinceName;
                this.modelProfile.districtName = this.objProfile.DistrictName;
                this.modelProfile.subDistrictName =
                    this.objProfile.SubDistrictName;
                // if (this.objProfile.birthDate) {
                //     // format date
                //     var date = moment.unix(this.objProfile.birthDate).utc();
                //     var y = date.format("YYYY");
                //     var m = date.format("M");
                //     var d = date.format("D");
                //     this.modelProfile.birthDate = new Date(y, m, d);
                // }

                this.isLoaded = true;
                this.handleLoading(false);
            } catch (err) {
                this.errorResponse(err, true);
            }
        },
        close: function () {
            this.$router.push("/profile");
        },
        clickSaveProfile: function () {
            this.isFirstSave = false;

            let token = Account.getToken();

            let nameArray = this.modelProfile.firstName.split(/(\s+)/);

            this.modelProfile.firstName = nameArray[0];
            this.modelProfile.LastName = nameArray[2];

            let params = this.modelProfile;

            // this.controller.loadingModal.show();
            BzbsProfile.updateProfile(token, params).subscribe(
                (data) => {
                    this.$bvModal.show("modalSuccessUpdate");
                    console.log(data);
                },
                (err) => {
                    this.$bvModal.show("modalFailUpdate");
                    console.log(err);
                }
            );
        },
        onDatePickerSelected: function (obj) {
            this.modelProfile.birthDate = obj.timestamp;
        },
        onFormChange: function () {
            this.$emit("onFormChange");
        },
        changeTel: function () {
            this.$router.push("/changetel");
        },
        //#region otp
        onclickOtp: async function () {
            this.tel = this.telNumber;
            await this.apiRequestOtp();
            //set timeout to 5 minutes
            this.timeHelper.initialTimer(60 * 5, null, false, false);
            this.startOtp();
        },
        apiRequestOtp: async function () {
            return new Promise((resolve, reject) => {
                BzbsOtp.requestOtp(this.tel, null, this.channel).subscribe(
                    (data) => {
                        this.refcode = data.refcode;
                        resolve(true);
                    },
                    (err) => {
                        console.log(err);
                        reject(false);
                    }
                );
            });
        },
        startOtp: async function () {
            this.isExpireTime = false;
            if (this.resend === false) {
                this.tel = this.telNumber;
            } else {
                this.timeHelper.stopTimer();
                this.timeHelper.resetTimer();
            }

            this.otp = "";

            this.isErrorMessage = false;

            this.timeHelper.runTimer(() => {
                this.setTimeout();
            });
            this.isExpireTime = true;
        },
        cancelOtp: function () {
            this.timeHelper.stopTimer();
            this.timeHelper.resetTimer();

            this.$store.commit("setDupphone", {
                isdup: false,
                message: "",
            });
        },
        onOtpChange: function () {
            this.otp = this.otp.replace(/\D/g, "");
            if (this.otp.length == 6) {
                this.validateBtn = false;
            } else {
                this.validateBtn = true;
                this.validateBorderOTP = true;
            }
        },
        setTimeout: function () {
            this.timeHelper.stopTimer();
            this.timeHelper.resetTimer();
            this.isExpireTime = false;
            //
            this.validateBorderOTP = true;
        },
        onSubmitOtp: async function () {
            if (this.validateOtp()) {
                await this.apiValidateOtp();
            }
        },
        apiValidateOtp: async function () {
            let token = Account.getToken();
            let params = {
                app_id: 147393556829911,
                contactNumber: this.telNumber,
                otp: this.otp,
                refcode: this.refcode,
                channel: "ssoupdate",
            };
            return new Promise((resolve, reject) => {
                BzbsProfile.updateProfileSSO(token, params).subscribe(
                    (data) => {
                        console.log(data);
                        this.$bvModal.show("modalSuccessUpdate");
                        AccountHelper.bzbsAnalyticTracking({
                            ScreenName: "profile",
                            Category: "profile",
                            Event: "mobile_update",
                            Action: "on view",
                            ContactNumber: this.telNumber,
                        });
                        resolve(true);
                    },
                    (err) => {
                        this.isErrorMessage = true;
                        this.errorMessage = err.message;
                        if (err.message === "รหัส OTP ไม่ถูกต้อง") {
                            this.errorMessage =
                                "รหัส OTP ไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง";
                        }
                        this.validateBorderOTP = false;
                        reject(false);
                    }
                );
            });
        },
        validateOtp: function () {
            if (this.otp && this.otp.length != 6) {
                this.errorMessage = this.lbl.otp.otpLength;
                if (this.otp == "") {
                    this.errorMessage = this.lbl.otp.requireInput;
                }
                this.isErrorMessage = true;
                return false;
            }
            return true;
        },
        resendOtp: async function () {
            this.isExpireTime = false;
            this.isErrorMessage = false;
            //
            this.validateBorderOTP = true;

            await this.clickResend();
            this.resend = true;
            await this.startOtp();
        },
        clickResend: async function () {
            return new Promise((resolve, reject) => {
                BzbsOtp.requestOtp(this.tel, null, this.channel).subscribe(
                    (data) => {
                        this.refcode = data.refcode;
                        resolve(true);
                    },
                    (err) => {
                        console.log(err);
                        reject(false);
                    }
                );
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/module/Profile/style/otp.scss";
.otp-desc-new {
    color: $color-text-light !important;
}
.contact-number {
    color: $color-text !important;
}
.ref-code {
    color: $color-brown-600 !important;
}
.resend {
    color: #544437 !important;
}
.resend-otp {
    color: #a7907b !important;
}
.box-input-otp {
    color: $color-text !important;
    &.error {
        color: #e73030 !important;
        border-color: #e73030 !important;
    }
}
@media (max-width: 380px) {
    .box-input-otp {
        width: 35px !important;
        height: 40px !important;
    }
}
</style>
